// frontend/src/components/common/StatusBanner.jsx
// Full-width strip that states a record's status, in the same colour
// vocabulary as StatusChip (the shared tokens live in StatusChip.css).

import './StatusChip.css';

export default function StatusBanner({ label, color = 'neutral', icon }) {
  return (
    <div className={`status-banner status-banner--${color}`} role="status">
      {icon && <span className="status-banner__icon">{icon}</span>}
      {label}
    </div>
  );
}
